// @flow
import $ from "jquery";
import React from "react";
import type { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import {
  extendedConvertToHTML,
  nativeInputToEditorState
} from "../utils/draftUtils.js";
import EmbedAssetButton from "./EmbedAssetButton.js";
import PreviewButton from "./PreviewButton.js";
import ApAssetBlock from "./ApAssetBlock.js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./ApEditor.scss";

export const EditorMode = {
  ITALIC: "ITALIC",
  SIMPLE: "SIMPLE",
  ADVANCED: "ADVANCED"
};

const ITALIC_TOOLBAR_OPTIONS = {
  options: ["inline"],
  inline: {
    inDropdown: false,
    className: undefined,
    options: ["italic"]
  }
};

const SIMPLE_TOOLBAR_OPTIONS = {
  options: ["inline", "list"],
  inline: {
    inDropdown: false,
    className: undefined,
    options: ["bold", "italic", "superscript", "subscript"]
  },
  list: {
    inDropdown: false,
    className: undefined,
    options: ["unordered", "ordered"]
  }
};

const ADVANCED_TOOLBAR_OPTIONS = {
  options: ["blockType", "inline", "list"],
  inline: {
    inDropdown: false,
    className: undefined,
    options: ["bold", "italic", "superscript", "subscript"]
  },
  blockType: {
    inDropdown: true,
    options: ["Normal", "H2", "H4", "Blockquote"],
    className: undefined,
    dropdownClassName: undefined
  },
  list: {
    inDropdown: false,
    className: undefined,
    options: ["unordered", "ordered"]
  }
};

const ADVANCED_CUSTOM_TOOLBAR_BUTTONS = [
  <EmbedAssetButton />,
  <PreviewButton />
];

function assetEmbedRenderer(contentBlock) {
  if (contentBlock.getType() == "atomic") {
    if (contentBlock.data.get("type") == "ap-asset") {
      return {
        component: ApAssetBlock,
        editable: false
      };
    }
  }
}

type Props = {
  nativeInput: HTMLInputElement,
  mode: string
};

export default class ApEditor extends React.Component {
  state: {
    editorState: EditorState
  };
  props: Props;

  constructor(props: Props) {
    super(props);
    (this: any).updateNativeInput = this.updateNativeInput.bind(this);
    (this: any).onFormSubmit = this.onFormSubmit.bind(this);
    (this: any).onChange = this.onChange.bind(this);

    this.state = {
      editorState: nativeInputToEditorState(props.nativeInput)
    };

    // set up event handler for when form is submitted
    $(this.props.nativeInput).parents("form").on("submit", this.onFormSubmit);
  }

  updateNativeInput() {
    const contentState = this.state.editorState.getCurrentContent();
    var html;
    if (contentState.getPlainText() === "") {
      html = "";
    } else {
      html = extendedConvertToHTML(contentState);
    }
    this.props.nativeInput.value = html;
  }

  onChange(editorState: EditorState) {
    this.setState({ editorState });
  }

  onFormSubmit() {
    this.updateNativeInput();
  }

  render() {
    let toolbarOptions = {},
      toolbarCustomButtons = [];
    switch (this.props.mode) {
      case EditorMode.ITALIC:
        toolbarOptions = ITALIC_TOOLBAR_OPTIONS;
        break;
      case EditorMode.SIMPLE:
        toolbarOptions = SIMPLE_TOOLBAR_OPTIONS;
        break;
      case EditorMode.ADVANCED:
        toolbarOptions = ADVANCED_TOOLBAR_OPTIONS;
        toolbarCustomButtons = ADVANCED_CUSTOM_TOOLBAR_BUTTONS;
        break;
    }

    return (
      <div className="ap-editor__container">
        <Editor
          stripPastedStyles={true}
          toolbar={toolbarOptions}
          toolbarCustomButtons={toolbarCustomButtons}
          editorState={this.state.editorState}
          onEditorStateChange={this.onChange}
          blockRendererFn={assetEmbedRenderer}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/ApEditor.js